(function () {
  'use strict';

  var VERSION = '15.0.0';
  var STORAGE_KEY = 'lmpGuidedCheckV14';
  var ROOT_SELECTOR = '[data-lmp-v14-check][data-lmp-version="15"]';
  var instances = new WeakMap();

  var ROLE_LABELS = {
    self: 'Schüler:in',
    child: 'Elternteil',
    teacher: 'Lehrkraft'
  };

  var SUBJECT_LABELS = {
    math: 'Mathe',
    german: 'Deutsch',
    english: 'Englisch',
    french: 'Französisch',
    spanish: 'Spanisch',
    latin: 'Latein',
    biology: 'Biologie',
    chemistry: 'Chemie',
    physics: 'Physik',
    geography: 'Erdkunde / Geografie',
    history: 'Geschichte',
    politics: 'Politik / Sozialkunde',
    primary_science: 'Sachunterricht',
    computer_science: 'Informatik',
    economics: 'Wirtschaft / Recht',
    ethics_religion: 'Ethik / Religion',
    art: 'Kunst',
    music: 'Musik',
    sports: 'Sport',
    multiple: 'mehrere Fächer',
    other: 'ein anderes Fach'
  };

  var SUBJECT_SEARCH_TOKENS = {
    math: ['mathe', 'mathematik'],
    german: ['deutsch'],
    english: ['englisch', 'english'],
    french: ['franzosisch', 'franzoesisch'],
    spanish: ['spanisch'],
    latin: ['latein'],
    biology: ['biologie'],
    chemistry: ['chemie'],
    physics: ['physik'],
    geography: ['erdkunde', 'geografie', 'geographie'],
    history: ['geschichte'],
    politics: ['politik', 'sozialkunde'],
    primary_science: ['sachunterricht'],
    computer_science: ['informatik'],
    economics: ['wirtschaft', 'recht'],
    ethics_religion: ['ethik', 'religion'],
    art: ['kunst'],
    music: ['musik'],
    sports: ['sport']
  };

  var STAGE_LABELS = {
    preschool: 'Vorschule / Schuleingang',
    primary: 'Grundschule',
    grade_5_7: '5.–7. Klasse',
    grade_8_10: '8.–10. Klasse',
    upper: 'Oberstufe / Abitur',
    vocational: 'Berufsschule / Ausbildung',
    cross_grade: 'stufenübergreifend',
    other: 'sonstige Stufe'
  };

  var GOAL_LABELS = {
    exam: 'Prüfung vorbereiten',
    understand: 'Thema verstehen',
    practice: 'Üben & festigen',
    improve: 'Langfristig besser werden',
    free: 'Kostenlos starten',
    personal: 'Persönliche Unterstützung',
    teach_prepare: 'Unterricht planen',
    teach_materials: 'Material finden / erstellen',
    teach_activate: 'Unterricht gestalten',
    teach_differentiate: 'Üben & differenzieren',
    teach_assess: 'Prüfen & bewerten',
    teach_organize: 'Organisieren & kommunizieren'
  };

  var HELP_LABELS = {
    auto: 'Check entscheidet',
    explanations: 'Erklärseiten & Übungen',
    podcasts: 'Podcasts & Hörgeschichten',
    listening: 'Englisch-Hörverstehen',
    worksheets: 'Arbeitsblätter',
    flashcards: 'Lernkarten',
    posters: 'Lernposter',
    summaries: 'Übersichten',
    books: 'Buch / Prüfungstrainer',
    digital: 'Digital & interaktiv',
    tutoring: 'Nachhilfe',
    ready_materials: 'Fertige Materialien',
    lesson_units: 'Unterrichtseinheiten',
    material_platforms: 'Materialplattformen',
    creation_tools: 'Erstellungs- & Planungstools',
    ai_tools: 'KI-Tools',
    interactive_tools: 'Interaktive Tools',
    school_tools: 'Organisation & Schulalltag'
  };

  var URGENCY_LABELS = {
    today: 'sofort / heute',
    week: 'diese Woche',
    month: 'in 2–4 Wochen',
    longterm: 'langfristig'
  };

  var TYPE_LABELS = {
    explanations: 'Erklärseite',
    podcasts: 'Podcast & Arbeitsblatt',
    listening: 'Hörverstehen',
    worksheets: 'Arbeitsblätter',
    flashcards: 'Lernkarten',
    posters: 'Lernposter',
    summaries: 'Übersichten',
    books: 'Bücher',
    exam_prep: 'Prüfungsvorbereitung',
    free: 'Kostenlos',
    platforms: 'Anbieter-Vergleich',
    apps: 'Lern-Apps',
    websites: 'Lernwebseiten',
    videos: 'Lernvideos',
    games: 'Lernspiele',
    tutoring: 'Nachhilfe-Vergleich',
    teacher_units: 'Unterrichtsmaterial',
    teacher_projects: 'Themenpakete',
    teacher_books: 'Fachliteratur',
    teacher_guides: 'Praxiswissen',
    material_platforms: 'Materialplattformen',
    planning_tools: 'Planungstools',
    creation_tools: 'Erstellungstools',
    ai_tools: 'KI-Tools',
    whiteboards: 'Whiteboards',
    interactive_tools: 'Interaktive Tools',
    video_tools: 'Erklärvideo-Tools',
    collaboration_tools: 'Zusammenarbeit',
    learning_paths: 'Lernpfade',
    practice_tools: 'Übungsplattformen',
    diagnostic_tools: 'Diagnostik',
    correction_tools: 'Korrektur',
    grading_tools: 'Bewertung',
    class_management: 'Klassenmanagement',
    messengers: 'Schulmessenger',
    lms: 'Lernmanagement',
    training: 'Fortbildungen',
    teacher_hub: 'Lehrkräfte-Übersicht'
  };

  var TYPE_SEARCH_TERMS = {
    worksheets: 'Arbeitsblätter',
    flashcards: 'Lernkarten',
    posters: 'Lernposter',
    books: 'Bücher',
    summaries: 'Zusammenfassungen',
    podcasts: 'Geschichtspodcasts'
  };

  var TYPE_SEARCH_TOKENS = {
    worksheets: ['arbeitsblatt', 'arbeitsblatter', 'ubungen'],
    flashcards: ['lernkarte', 'lernkarten'],
    posters: ['lernposter', 'lernplakat'],
    books: ['buch', 'bucher'],
    summaries: ['ubersicht', 'zusammenfassung'],
    podcasts: ['geschichtspodcast', 'horgeschichte']
  };

  var LEARNER_GOAL_WEIGHTS = {
    exam: { explanations: 43, podcasts: 25, listening: 31, exam_prep: 52, worksheets: 44, flashcards: 38, summaries: 34, books: 29, tutoring: 25, posters: 20, platforms: 18, videos: 14 },
    understand: { explanations: 63, podcasts: 46, listening: 32, worksheets: 31, videos: 45, posters: 38, websites: 34, books: 31, summaries: 28, platforms: 24, tutoring: 18, flashcards: 12 },
    practice: { explanations: 37, podcasts: 27, listening: 45, worksheets: 49, apps: 36, platforms: 34, flashcards: 31, websites: 23, books: 20, games: 19, videos: 15 },
    improve: { explanations: 43, podcasts: 29, listening: 38, platforms: 40, books: 34, tutoring: 32, apps: 30, worksheets: 26, websites: 21, flashcards: 18 },
    free: { explanations: 57, podcasts: 43, listening: 43, free: 65, worksheets: 47, flashcards: 40, posters: 37, websites: 36, videos: 34, apps: 31, games: 24 },
    personal: { explanations: 20, tutoring: 60, platforms: 28, books: 22, videos: 20, websites: 15 }
  };

  var TEACHER_GOAL_WEIGHTS = {
    teach_prepare: { explanations: 34, podcasts: 28, listening: 24, planning_tools: 48, teacher_units: 45, material_platforms: 39, teacher_projects: 33, ai_tools: 29, teacher_books: 22, teacher_guides: 20 },
    teach_materials: { explanations: 38, podcasts: 43, listening: 40, teacher_units: 49, material_platforms: 47, worksheets: 40, teacher_projects: 38, creation_tools: 35, ai_tools: 32, posters: 25, flashcards: 22, teacher_books: 18 },
    teach_activate: { explanations: 52, podcasts: 57, listening: 50, interactive_tools: 49, whiteboards: 42, video_tools: 39, collaboration_tools: 36, teacher_units: 30, ai_tools: 24, posters: 20 },
    teach_differentiate: { explanations: 41, podcasts: 29, listening: 38, learning_paths: 51, practice_tools: 46, worksheets: 38, interactive_tools: 30, diagnostic_tools: 24, teacher_units: 21, platforms: 18 },
    teach_assess: { diagnostic_tools: 51, correction_tools: 47, grading_tools: 42, interactive_tools: 24, ai_tools: 22, practice_tools: 18 },
    teach_organize: { class_management: 47, lms: 45, messengers: 43, planning_tools: 28, collaboration_tools: 22, teacher_hub: 18 }
  };

  var HELP_BOOSTS = {
    explanations: { explanations: 72, worksheets: 14 },
    podcasts: { podcasts: 72, explanations: 15, worksheets: 12 },
    listening: { listening: 72, worksheets: 20 },
    worksheets: { worksheets: 64 },
    flashcards: { flashcards: 64 },
    posters: { posters: 64 },
    summaries: { summaries: 64 },
    books: { books: 58, exam_prep: 25 },
    digital: { explanations: 46, podcasts: 35, listening: 38, platforms: 42, apps: 40, websites: 35, videos: 35, games: 28 },
    tutoring: { tutoring: 68 },
    ready_materials: { explanations: 35, podcasts: 44, listening: 40, teacher_units: 54, teacher_projects: 48, worksheets: 46, posters: 35, flashcards: 32, teacher_books: 20 },
    lesson_units: { explanations: 25, podcasts: 30, listening: 25, teacher_units: 68, teacher_projects: 34 },
    material_platforms: { material_platforms: 68 },
    creation_tools: { creation_tools: 58, planning_tools: 48, ai_tools: 30 },
    ai_tools: { ai_tools: 68 },
    interactive_tools: { interactive_tools: 58, whiteboards: 42, video_tools: 35, collaboration_tools: 30 },
    school_tools: { class_management: 52, lms: 48, messengers: 46, grading_tools: 24, training: 20 }
  };

  function resource(type, title, url, text, options) {
    var settings = options || {};
    return {
      type: type,
      title: title,
      url: url,
      text: text,
      exact: Boolean(settings.exact),
      free: Boolean(settings.free),
      live: Boolean(settings.live),
      subject: settings.subject || '',
      kind: settings.kind || (url.indexOf('/collections/') !== -1 ? 'collection' : 'comparison'),
      image: settings.image || '',
      topicMatch: settings.topicMatch || 0,
      gradeLabel: settings.gradeLabel || '',
      stageKnown: Boolean(settings.stageKnown),
      badge: settings.badge || TYPE_LABELS[type] || 'Empfehlung'
    };
  }

  var SUBJECT_RESOURCES = {
    math: [
      resource('worksheets', 'Mathe-Arbeitsblätter', '/collections/arbeitsblatter', 'Aufgaben zum Ausdrucken und gezielten Üben.', { exact: true }),
      resource('flashcards', 'Mathe-Lernkarten', '/collections/mathe-lernkarten-rechenregeln-formeln-grundlagen-einfach-merken', 'Rechenregeln und Formeln kompakt wiederholen.', { exact: true }),
      resource('posters', 'Mathematik-Lernposter', '/collections/mathematik-lernposter-lernplakate-zum-ausdrucken', 'Zentrale Regeln und Zusammenhänge auf einen Blick.', { exact: true }),
      resource('books', 'Mathe-Bücher & Prüfungstrainer', '/collections/mathe-buecher', 'Ausführliche Erklärungen und systematisches Training.', { exact: true })
    ],
    german: [
      resource('worksheets', 'Deutsch-Arbeitsblätter', '/collections/deutsch-arbeitsblaetter', 'Rechtschreibung, Grammatik und Sprache gezielt üben.', { exact: true }),
      resource('flashcards', 'Deutsch-Lernkarten', '/collections/deutsch-lernkarten-grammatik-rechtschreibung-satzbau-auf-einen-blick', 'Grammatik, Rechtschreibung und Satzbau kompakt sichern.', { exact: true }),
      resource('posters', 'Deutsch-Lernposter', '/collections/deutsch-lernposter-lernplakate-zum-ausdrucken', 'Sprachregeln als übersichtliche Lernhilfe.', { exact: true }),
      resource('books', 'Deutsch-Bücher & Lernhilfen', '/collections/deutsch-buecher', 'Vertiefende Lernhilfen für verschiedene Klassenstufen.', { exact: true })
    ],
    english: [
      resource('worksheets', 'Englisch-Arbeitsblätter', '/collections/englisch-arbeitsblaetter', 'Grammatik, Wortschatz und Textarbeit praktisch trainieren.', { exact: true }),
      resource('flashcards', 'Englisch-Lernkarten', '/collections/englisch-lernkarten-vokabeln-grammatik-satzbau-einfach-erklart', 'Vokabeln, Grammatik und Satzbau schnell wiederholen.', { exact: true }),
      resource('posters', 'Englisch-Lernposter', '/collections/englisch-lernposter-lernplakate-zum-ausdrucken', 'Wichtige Sprachregeln übersichtlich darstellen.', { exact: true }),
      resource('books', 'Englisch-Bücher & Lernhilfen', '/collections/englisch-buecher', 'Vom Grundlagenbuch bis zur Prüfungsvorbereitung.', { exact: true })
    ],
    french: [
      resource('worksheets', 'Französisch-Arbeitsblätter', '/collections/franzoesisch-arbeitsblaetter', 'Wortschatz und Grammatik mit passenden Übungen festigen.', { exact: true }),
      resource('books', 'Französisch-Bücher & Lernhilfen', '/collections/franzoesisch-buecher', 'Französisch strukturiert lernen und vertiefen.', { exact: true })
    ],
    spanish: [
      resource('worksheets', 'Spanisch-Arbeitsblätter', '/collections/spanisch-arbeitsblatter-grammatik-wortschatz-ubungen', 'Grammatik und Wortschatz mit Übungen trainieren.', { exact: true }),
      resource('books', 'Spanisch-Bücher & Lernhilfen', '/collections/spanisch-buecher', 'Passende Lernhilfen für Aufbau und Vertiefung.', { exact: true })
    ],
    latin: [
      resource('books', 'Latein-Bücher & Lernhilfen', '/collections/latein-buecher', 'Grammatik, Übersetzung und Wortschatz systematisch üben.', { exact: true })
    ],
    biology: [
      resource('posters', 'Biologie-Lernposter', '/collections/biologie-lernposter-lernplakate-zum-ausdrucken', 'Biologische Abläufe und Fachbegriffe visuell erfassen.', { exact: true }),
      resource('books', 'Biologie-Bücher & Lernhilfen', '/collections/biologie-buecher', 'Themen fundiert verstehen und vertiefen.', { exact: true })
    ],
    chemistry: [
      resource('posters', 'Chemie-Lernposter', '/collections/chemie-lernposter-lernplakate-zum-ausdrucken', 'Formeln, Modelle und Zusammenhänge sichtbar machen.', { exact: true }),
      resource('books', 'Chemie-Bücher & Lernhilfen', '/collections/chemie-buecher', 'Grundlagen und Aufgaben Schritt für Schritt bearbeiten.', { exact: true })
    ],
    physics: [
      resource('worksheets', 'Kostenlose Physik-Arbeitsblätter', '/collections/physik-arbeitsblaetter', 'Physikalische Zusammenhänge mit passenden Aufgaben anwenden.', { exact: true, free: true }),
      resource('flashcards', 'Physik-Lernkarten', '/collections/physik-lernkarten', 'Formeln, Größen und Grundbegriffe kompakt wiederholen.', { exact: true }),
      resource('posters', 'Physik-Lernposter', '/collections/physik-lernposter-lernplakate-zum-ausdrucken', 'Formeln und Modelle als visuelle Merkhilfe.', { exact: true }),
      resource('books', 'Physik-Bücher & Lernhilfen', '/collections/physik-buecher', 'Erklärungen und Übungsaufgaben für verschiedene Stufen.', { exact: true })
    ],
    geography: [
      resource('posters', 'Erdkunde-Lernposter', '/collections/erdkunde-lernposter-lernplakate-zum-ausdrucken', 'Räume, Prozesse und Fachbegriffe anschaulich lernen.', { exact: true }),
      resource('books', 'Erdkunde-Bücher & Lernhilfen', '/collections/erdkunde-buecher', 'Geografische Themen strukturiert erarbeiten.', { exact: true })
    ],
    history: [resource('books', 'Geschichte-Bücher & Lernhilfen', '/collections/geschichte-buecher', 'Epochen und Zusammenhänge fundiert erschließen.', { exact: true })],
    politics: [resource('books', 'Politik- & Sozialkunde-Bücher', '/collections/sozialkunde-buecher', 'Politische und gesellschaftliche Themen verständlich vertiefen.', { exact: true })],
    primary_science: [resource('books', 'Lernhilfen für die Grundschule', '/collections/grundschule', 'Altersgerechte Materialien für den Schuleinstieg und die Grundschule.', { exact: true })],
    economics: [resource('books', 'Wirtschaft-Bücher & Lernhilfen', '/collections/wirtschaft-buecher', 'Wirtschaftliche Grundlagen und Zusammenhänge erarbeiten.', { exact: true })],
    art: [resource('books', 'Kunst-Bücher & Lernhilfen', '/collections/kunst-buecher', 'Kunstwissen und Gestaltungsideen vertiefen.', { exact: true })]
  };

  var LEARNER_RESOURCES = [
    resource('worksheets', 'Kostenlose Arbeitsblätter', '/collections/alle-kostenlosen-arbeitsblaetter', 'Viele direkt nutzbare Arbeitsblätter für unterschiedliche Fächer.', { free: true }),
    resource('flashcards', 'Alle Lernkarten', '/collections/lernkarten', 'Kompakte Karten zum Wiederholen, Abfragen und Festigen.'),
    resource('posters', 'Alle Lernposter & Lernplakate', '/collections/lernposter-lernplakate', 'Visuelle Übersichten zum Aufhängen oder Ausdrucken.'),
    resource('summaries', 'Übersichten & Zusammenfassungen', '/collections/ubersichten-zusammenfassungen', 'Wichtige Inhalte kurz und strukturiert zusammenfassen.'),
    resource('books', 'Alle Bücher & Lernhilfen', '/collections/all', 'Lernhilfen, Übungsbücher und Prüfungstrainer entdecken.'),
    resource('exam_prep', 'Materialien zur Prüfungsvorbereitung', '/collections/prufungsvorbereitung', 'Gezielt wiederholen, typische Aufgaben trainieren und Lücken schließen.'),
    resource('free', 'Die besten kostenlosen Lernangebote', '/pages/die-besten-kostenlosen-lernangebote', 'Kostenlose Materialien und digitale Angebote gebündelt finden.', { free: true }),
    resource('platforms', 'Lernplattformen im Vergleich', '/pages/lernplattformen-vergleich', 'Funktionen, Zielgruppen und Angebote übersichtlich vergleichen.'),
    resource('apps', 'Kostenlose Lern-Apps', '/collections/kostenlose-lernapps', 'Mobil und interaktiv üben – ohne direkt Geld auszugeben.', { free: true }),
    resource('websites', 'Kostenlose Lernwebseiten', '/collections/kostenlose-lernwebseiten', 'Erklärungen und Übungen online nutzen.', { free: true }),
    resource('videos', 'Kostenlose Lernvideos', '/collections/kostenlose-lernvideos', 'Themen anschaulich erklären lassen und im eigenen Tempo ansehen.', { free: true }),
    resource('games', 'Lernspiele für Schüler & Familien', '/collections/lernspiele-fuer-schueler-eltern', 'Spielerisch wiederholen und Motivation aufbauen.'),
    resource('tutoring', 'Nachhilfeanbieter im Überblick', '/pages/nachhilfeanbieter-im-uberblick-finde-die-passende-nachhilfe', 'Modelle und Anbieter vergleichen, bevor eine Entscheidung fällt.')
  ];

  var TEACHER_RESOURCES = [
    resource('teacher_units', 'Unterrichtseinheiten & Unterrichtsreihen', '/collections/unterrichtseinheiten-unterrichtsreihen', 'Direkt einsetzbare Bausteine für Stunden und Reihen.'),
    resource('teacher_projects', 'Themenpakete & Projektmaterial', '/collections/themenpakete-projektmaterial-fur-den-unterricht', 'Größere Themen und Projekte mit abgestimmtem Material umsetzen.'),
    resource('teacher_books', 'Bücher für Lehrkräfte', '/collections/buecher-fuer-lehrkraefte', 'Didaktik, Fachwissen und Unterrichtspraxis vertiefen.'),
    resource('teacher_guides', 'Material & Fachliteratur für Lehrkräfte', '/pages/material-fachliteratur-fur-lehrkrafte-praxisnah-fundiert-sofort-einsetzbar', 'Praxisnahe Materialien und Fachliteratur gebündelt entdecken.'),
    resource('material_platforms', 'Plattformen für Unterrichtsmaterialien', '/pages/die-besten-plattformen-fuer-unterrichtsmaterialien', 'Materialplattformen nach Angebot und Einsatzbereich vergleichen.'),
    resource('planning_tools', 'Stoffverteilungs- & Jahresplaner', '/pages/digitale-stoffverteilungs-jahresplaner-fuer-lehrkraefte-im-vergleich', 'Unterricht, Reihen und Schuljahr digital strukturieren.'),
    resource('creation_tools', 'Tools zur Materialerstellung', '/pages/die-besten-tools-fur-materialerstellung-im-vergleich', 'Arbeitsblätter, Präsentationen und Inhalte effizient erstellen.'),
    resource('ai_tools', 'KI-Tools für Lehrkräfte im Vergleich', '/pages/ki-tools-fuer-lehrer-im-vergleich-angebote-funktionen-erfahrungen', 'KI-Werkzeuge für Planung, Differenzierung und Materialerstellung vergleichen.'),
    resource('whiteboards', 'Digitale Whiteboards', '/pages/digitale-whiteboards-fuer-unterricht', 'Tafelbilder, Visualisierungen und Zusammenarbeit digital gestalten.'),
    resource('interactive_tools', 'Interaktive Übungen & Lernspiele', '/pages/interaktive-uebungen-lernspiele-fuer-den-unterricht-anbieter-im-vergleich', 'Aktivierende Aufgaben und spielerische Formate vergleichen.'),
    resource('video_tools', 'Plattformen für Erklärvideos & Lerninhalte', '/pages/die-besten-plattformen-fuer-erklaervideos-lerninhalte-im-vergleich', 'Erklärinhalte finden oder für den Unterricht aufbereiten.'),
    resource('collaboration_tools', 'Digitale Zusammenarbeit im Unterricht', '/pages/kooperatives-lernen-digitale-zusammenarbeit-im-unterricht-anbieter-im-vergleich', 'Kooperative Lernformen mit passenden Werkzeugen unterstützen.'),
    resource('learning_paths', 'Digitale Lernpfade & individuelles Lernen', '/pages/individuelles-lernen-digitale-lernpfade-im-unterricht-vergleich-fuer-lehrkraefte', 'Differenzierte Lernwege planen und begleiten.'),
    resource('practice_tools', 'Übungsplattformen & Hausaufgaben-Tools', '/pages/die-besten-ubungsplattformen-hausaufgaben-tools-im-vergleich', 'Üben, Hausaufgaben und Rückmeldungen digital organisieren.'),
    resource('diagnostic_tools', 'Lernstandsdiagnostik & Kompetenzraster', '/pages/lernstandsdiagnostik-kompetenzraster-im-digitalen-unterricht-anbieter-im-vergleich', 'Lernstände erfassen und Förderung fundiert planen.'),
    resource('correction_tools', 'Digitale Korrektur & Auto-Bewertung', '/pages/digitale-korrektur-auto-bewertungstools-vergleich-fuer-lehrkraefte', 'Korrektur- und Feedbackprozesse effizienter gestalten.'),
    resource('grading_tools', 'Notenverwaltung & Bewertungs-Apps', '/pages/digitale-notenverwaltung-bewertungs-apps-im-vergleich', 'Leistungen dokumentieren und Bewertungen organisieren.'),
    resource('class_management', 'Klassenmanagement & Organisation', '/pages/klassenmanagement-organisation-tools-vergleich', 'Aufgaben, Termine und Abläufe im Schulalltag bündeln.'),
    resource('messengers', 'DSGVO-konforme Schulmessenger', '/pages/kommunikation-mit-schuelern-eltern-dsgvo-konforme-schulmessenger-im-vergleich', 'Kommunikation mit Schüler:innen und Eltern vergleichen.'),
    resource('lms', 'LMS & digitale Klassenräume', '/pages/lms-digitale-klassenraeume', 'Kurse, Materialien und Kommunikation zentral organisieren.'),
    resource('training', 'Fortbildungen für Lehrkräfte', '/pages/fortbildungen-weiterbildung-fuer-lehrkraefte-anbieter-im-vergleich', 'Passende Weiterbildungen und Anbieter finden.'),
    resource('teacher_hub', 'Alle digitalen Tools für Lehrkräfte', '/pages/digitale-tools-fur-lehrkrafte-die-besten-plattformen-im-vergleich', 'Die wichtigsten Tool-Kategorien an einem Ort vergleichen.')
  ];

  function init(root) {
    if (!root || instances.has(root)) return;

    var form = root.querySelector('[data-lmp-v14-finder]');
    if (!form) return;

    var ui = {
      form: form,
      steps: Array.prototype.slice.call(root.querySelectorAll('[data-lmp-v14-step]')),
      stepLabel: root.querySelector('[data-lmp-v14-step-label]'),
      progress: root.querySelector('[data-lmp-v14-progress]'),
      progressBar: root.querySelector('[data-lmp-v14-progress-bar]'),
      error: root.querySelector('[data-lmp-v14-error]'),
      back: root.querySelector('[data-lmp-v14-back]'),
      next: root.querySelector('[data-lmp-v14-next]'),
      submit: root.querySelector('[data-lmp-v14-submit]'),
      panels: Array.prototype.slice.call(root.querySelectorAll('[data-lmp-v14-role-panel]')),
      stageLabel: root.querySelector('[data-lmp-v14-stage-label]'),
      goalLegend: root.querySelector('[data-lmp-v14-goal-legend]'),
      goalHint: root.querySelector('[data-lmp-v14-goal-hint]'),
      helpLegend: root.querySelector('[data-lmp-v14-help-legend]'),
      topic: root.querySelector('[data-lmp-v14-topic]'),
      topicHint: root.querySelector('[data-lmp-v14-topic-hint]'),
      placeholder: root.querySelector('[data-lmp-v14-placeholder]'),
      output: root.querySelector('[data-lmp-v14-output]'),
      status: root.querySelector('[data-lmp-v14-status]'),
      resultTitle: root.querySelector('[data-lmp-v14-result-title]'),
      resultLead: root.querySelector('[data-lmp-v14-result-lead]'),
      resultKicker: root.querySelector('[data-lmp-v14-result-kicker]'),
      summary: root.querySelector('[data-lmp-v14-summary]'),
      notice: root.querySelector('[data-lmp-v14-notice]'),
      primary: root.querySelector('[data-lmp-v14-primary]'),
      liveWrap: root.querySelector('[data-lmp-v14-live-wrap]'),
      live: root.querySelector('[data-lmp-v14-live]'),
      lookup: root.querySelector('[data-lmp-v14-lookup]'),
      alternativesWrap: root.querySelector('[data-lmp-v14-alternatives-wrap]'),
      alternatives: root.querySelector('[data-lmp-v14-alternatives]'),
      ai: root.querySelector('[data-lmp-v14-ai]'),
      result: root.querySelector('[data-lmp-v14-result]'),
      more: root.querySelector('[data-lmp-v15-more]'),
      moreLabel: root.querySelector('[data-lmp-v15-more-label]'),
      moreList: root.querySelector('[data-lmp-v15-more-list]'),
      edit: root.querySelector('[data-lmp-v14-edit]'),
      email: root.querySelector('[data-lmp-v14-email]'),
      hiddenTags: root.querySelector('[data-lmp-v14-hidden-tags]'),
      hiddenNote: root.querySelector('[data-lmp-v14-hidden-note]')
    };

    var state = {
      step: 1,
      generation: 0,
      currentResult: null,
      cache: new Map()
    };

    var instance = { root: root, ui: ui, state: state, catalog: readCatalog(root) };
    root.classList.add('is-ready');
    keepNativeSelects(instance);
    instances.set(root, instance);

    restoreForm(instance);
    updateRoleUI(instance);
    goToStep(instance, 1, false);

    form.addEventListener('change', function (event) {
      if (event.target && event.target.name === 'lmp_role') updateRoleUI(instance);
      updateFormatChoices(instance);
      clearError(ui);
    });

    ui.next.addEventListener('click', function () {
      if (validateStep(instance, state.step)) goToStep(instance, state.step + 1, true);
    });

    ui.back.addEventListener('click', function () {
      goToStep(instance, Math.max(1, state.step - 1), true);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var invalidStep = firstInvalidStep(instance);
      if (invalidStep) {
        goToStep(instance, invalidStep, true);
        validateStep(instance, invalidStep);
        return;
      }
      generateRecommendation(instance);
    });

    ui.edit.addEventListener('click', function () {
      state.generation += 1;
      ui.output.hidden = true;
      ui.placeholder.hidden = true;
      ui.form.hidden = false;
      ui.result.hidden = true;
      instance.root.classList.remove('has-result');
      ui.lookup.hidden = true;
      goToStep(instance, 1, true);
      track('edit', getFormState(instance));
    });
  }

  function restoreForm(instance) {
    var saved;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY + (instance.root.getAttribute('data-lmp-v14-default-role') === 'teacher' ? ':teacher' : '')) || 'null');
    } catch (error) {
      saved = null;
    }
    if (!saved || saved.version !== VERSION || !saved.values) return;

    Object.keys(saved.values).forEach(function (name) {
      var value = saved.values[name];
      var fields = instance.ui.form.elements[name];
      if (!fields) return;
      var list = fields.length && !fields.tagName ? Array.prototype.slice.call(fields) : [fields];
      list.forEach(function (field) {
        if (field.type === 'radio' || field.type === 'checkbox') field.checked = field.value === value;
        else field.value = value;
      });
    });
  }

  function saveForm(state, instance) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY + (instance.root.getAttribute('data-lmp-v14-default-role') === 'teacher' ? ':teacher' : ''), JSON.stringify({
        version: VERSION,
        values: {
          lmp_role: state.role,
          lmp_subject: state.subject,
          lmp_stage: state.stage,
          lmp_goal_learner: state.role === 'teacher' ? '' : state.goal,
          lmp_goal_teacher: state.role === 'teacher' ? state.goal : '',
          lmp_help_learner: state.role === 'teacher' ? 'auto' : state.help,
          lmp_help_teacher: state.role === 'teacher' ? state.help : 'auto',
          lmp_topic: state.topic,
          lmp_urgency: state.urgency
        }
      }));
    } catch (error) {
      
    }
  }

  function updateRoleUI(instance) {
    var roleField = instance.ui.form.querySelector('input[name="lmp_role"]:checked');
    var role = roleField ? roleField.value : 'self';
    var teacher = role === 'teacher';

    instance.root.classList.toggle('is-teacher', teacher);
    instance.ui.panels.forEach(function (panel) {
      var active = panel.getAttribute('data-lmp-v14-role-panel') === (teacher ? 'teacher' : 'learner');
      panel.hidden = !active;
      Array.prototype.slice.call(panel.querySelectorAll('input, select, textarea')).forEach(function (field) {
        field.disabled = !active;
      });
    });

    updateFormatChoices(instance);
    instance.ui.stageLabel.textContent = teacher ? 'Klassenstufe / Bildungsgang' : 'Klasse / Stufe';
    instance.ui.goalLegend.textContent = teacher ? 'Was möchtest du für deinen Unterricht erreichen?' : 'Was möchtest du erreichen?';
    instance.ui.goalHint.textContent = teacher ? 'Wähle den Bereich, der dich gerade am meisten entlasten soll.' : 'Wähle das Ziel, das gerade am wichtigsten ist.';
    instance.ui.helpLegend.textContent = teacher ? 'Welche Art von Unterstützung suchst du?' : 'Was passt am besten zu dir?';
    instance.ui.topic.placeholder = teacher ? 'z. B. Elektrizitätslehre Klasse 8 oder Bruchrechnung differenzieren' : 'z. B. Ohmsches Gesetz oder Bruchgleichungen';
    instance.ui.topicHint.textContent = teacher ? 'Damit kann der Check fachlich passende Materialien finden und den KI-Assistenten konkreter vorbereiten.' : 'Damit kann der Check aktuelle Direkt-Treffer finden und die KI gezielter starten.';
  }

  function goToStep(instance, step, focus) {
    var nextStep = Math.min(3, Math.max(1, step));
    instance.state.step = nextStep;
    instance.ui.steps.forEach(function (panel) {
      var active = Number(panel.getAttribute('data-lmp-v14-step')) === nextStep;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    instance.ui.stepLabel.textContent = 'Schritt ' + nextStep + ' von 3';
    instance.ui.progress.setAttribute('aria-valuenow', String(nextStep));
    instance.ui.progressBar.style.width = String((nextStep / 3) * 100) + '%';
    instance.ui.back.hidden = nextStep === 1;
    instance.ui.next.hidden = nextStep === 3;
    instance.ui.submit.hidden = nextStep !== 3;
    clearError(instance.ui);

    if (focus) {
      var legend = instance.ui.steps[nextStep - 1].querySelector('legend');
      if (legend) {
        legend.setAttribute('tabindex', '-1');
        legend.focus({ preventScroll: true });
      }
    }
  }

  function firstInvalidStep(instance) {
    if (!validateStep(instance, 1, true)) return 1;
    if (!validateStep(instance, 2, true)) return 2;
    return 0;
  }

  function validateStep(instance, step, silent) {
    var form = instance.ui.form;
    var message = '';
    var focusTarget = null;

    if (step === 1) {
      var subject = form.elements.lmp_subject;
      var stage = form.elements.lmp_stage;
      if (!subject.value) {
        message = 'Bitte wähle zuerst ein Fach aus.';
        focusTarget = subject;
      } else if (!stage.value) {
        message = 'Bitte wähle eine Klasse oder Stufe aus.';
        focusTarget = stage;
      }
    }

    if (step === 2) {
      var roleField = form.querySelector('input[name="lmp_role"]:checked');
      var goalName = roleField && roleField.value === 'teacher' ? 'lmp_goal_teacher' : 'lmp_goal_learner';
      var goal = form.querySelector('input[name="' + goalName + '"]:checked');
      if (!goal) {
        message = roleField && roleField.value === 'teacher' ? 'Bitte wähle ein Ziel für deinen Unterricht.' : 'Bitte wähle dein wichtigstes Lernziel.';
        focusTarget = form.querySelector('input[name="' + goalName + '"]:not([disabled])');
      }
    }

    if (message) {
      if (!silent) showError(instance.ui, message, focusTarget);
      return false;
    }
    return true;
  }

  function showError(ui, message, target) {
    ui.error.textContent = message;
    ui.error.hidden = false;
    if (target) target.focus();
  }

  function clearError(ui) {
    ui.error.hidden = true;
    ui.error.textContent = '';
  }

  function getFormState(instance) {
    var form = instance.ui.form;
    var roleNode = form.querySelector('input[name="lmp_role"]:checked');
    var role = roleNode ? roleNode.value : 'self';
    var goalName = role === 'teacher' ? 'lmp_goal_teacher' : 'lmp_goal_learner';
    var helpName = role === 'teacher' ? 'lmp_help_teacher' : 'lmp_help_learner';
    var goalNode = form.querySelector('input[name="' + goalName + '"]:checked');
    var helpNode = form.querySelector('input[name="' + helpName + '"]:checked');

    return {
      role: role,
      subject: form.elements.lmp_subject.value,
      stage: form.elements.lmp_stage.value,
      goal: goalNode ? goalNode.value : '',
      help: helpNode ? helpNode.value : 'auto',
      topic: String(form.elements.lmp_topic.value || '').trim().slice(0, 120),
      urgency: form.elements.lmp_urgency.value || ''
    };
  }

  function generateRecommendation(instance) {
    var formState = getFormState(instance);
    instance.state.generation += 1;
    var generation = instance.state.generation;
    saveForm(formState, instance);

    var candidates = buildCandidates(instance, formState);
    var ranked = rankCandidates(candidates, formState);
    var result = selectResult(ranked);
    instance.state.currentResult = result;

    renderResult(instance, formState, result, []);
    instance.ui.placeholder.hidden = true;
    instance.ui.output.hidden = false;
    instance.ui.result.hidden = false;
    instance.ui.form.hidden = true;
    instance.root.classList.add('has-result');
    instance.ui.status.textContent = 'Deine persönliche Empfehlung ist fertig.';
    instance.ui.resultTitle.focus({ preventScroll: true });
    updateEmailFields(instance, formState);
    track('result', formState, result.primary);

    if (window.matchMedia && window.matchMedia('(max-width: 980px)').matches) {
      instance.root.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    if (String(instance.root.getAttribute('data-lmp-v14-live-enabled')) === 'true') {
      enhanceWithLiveSearch(instance, formState, candidates, generation);
    }
  }

  function buildCandidates(instance, state) {
    var base = state.role === 'teacher' ? TEACHER_RESOURCES.concat(LEARNER_RESOURCES) : LEARNER_RESOURCES.slice();
    var subjectSpecific = SUBJECT_RESOURCES[state.subject] || [];
    var own = instance.catalog.filter(function (item) {
      return item.subject === state.subject && formatAvailable(item.type, state);
    });
    return dedupeResources(own.concat(subjectSpecific, base)).filter(function (item) {
      return eligible(item, state);
    });
  }

  function dedupeResources(items) {
    var seen = Object.create(null);
    return items.filter(function (item) {
      var key = canonicalPath(item.url);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function rankCandidates(candidates, state) {
    return candidates.map(function (item, index) {
      return { resource: item, score: scoreResource(item, state), order: index };
    }).sort(function (a, b) {
      return b.score - a.score || a.order - b.order;
    });
  }

  function scoreResource(item, state) {
    var score = 10;
    var goalWeights = state.role === 'teacher' ? TEACHER_GOAL_WEIGHTS[state.goal] : LEARNER_GOAL_WEIGHTS[state.goal];
    if (goalWeights && goalWeights[item.type]) score += goalWeights[item.type];

    var helpWeights = HELP_BOOSTS[state.help];
    if (helpWeights && helpWeights[item.type]) score += helpWeights[item.type];

    if (item.exact) score += state.role === 'teacher' ? 19 : 27;
    if (item.live) score += 4;
    if (item.topicMatch) score += Math.round(item.topicMatch * 45);
    if (item.stageKnown) score += 14;
    if (state.urgency === 'today' && ['explanations', 'podcasts', 'listening'].indexOf(item.type) !== -1) score += 11;

    if (state.goal === 'free') {
      score += item.free ? 22 : -24;
    }

    if (state.stage === 'preschool' || state.stage === 'primary') {
      if (item.type === 'worksheets') score += 14;
      if (item.type === 'games') score += 13;
      if (item.type === 'posters') score += 10;
      if (item.type === 'books') score += 6;
    }

    if (state.stage === 'upper') {
      if (item.type === 'exam_prep') score += 16;
      if (item.type === 'summaries') score += 10;
      if (item.type === 'books') score += 8;
    }

    if (state.urgency === 'today') {
      if (['worksheets', 'flashcards', 'summaries', 'videos', 'teacher_units', 'interactive_tools'].indexOf(item.type) !== -1) score += 11;
      if (['training', 'books', 'teacher_books'].indexOf(item.type) !== -1) score -= 5;
    } else if (state.urgency === 'week') {
      if (['worksheets', 'flashcards', 'summaries', 'teacher_units', 'teacher_projects', 'practice_tools'].indexOf(item.type) !== -1) score += 7;
    } else if (state.urgency === 'longterm') {
      if (['books', 'platforms', 'tutoring', 'planning_tools', 'learning_paths', 'lms', 'training'].indexOf(item.type) !== -1) score += 8;
    }

    if (state.role === 'teacher' && ['free', 'apps', 'websites', 'videos', 'games', 'tutoring'].indexOf(item.type) !== -1) score -= 8;
    return score;
  }

  function selectResult(ranked) {
    var primary = ranked[0].resource;
    var usedTypes = Object.create(null);
    usedTypes[primary.type] = true;
    var companions = [];
    ranked.slice(1).forEach(function (entry) {
      if (usedTypes[entry.resource.type] || entry.score < Math.max(32, ranked[0].score * 0.34)) return;
      companions.push(entry.resource);
      usedTypes[entry.resource.type] = true;
    });
    return { primary: primary, alternatives: companions.slice(0, 2), more: companions.slice(2), ranked: ranked };
  }

  function renderResult(instance, state, result) {
    var ui = instance.ui;
    ui.resultKicker.textContent = state.role === 'teacher' ? 'Deine Unterrichts-Empfehlung' : state.role === 'child' ? 'Empfehlung für dein Kind' : 'Deine Lernhilfe-Empfehlung';
    ui.resultTitle.textContent = 'Hier kannst du anfangen.';
    ui.resultLead.textContent = 'Ein passender Einstieg und sinnvolle Ergänzungen.';
    var chips = [SUBJECT_LABELS[state.subject], STAGE_LABELS[state.stage], GOAL_LABELS[state.goal]];
    if (state.help && state.help !== 'auto') chips.push(HELP_LABELS[state.help]);
    if (state.topic) chips.push(state.topic);
    ui.summary.innerHTML = chips.filter(Boolean).map(function (label) { return '<span>' + escapeHTML(label) + '</span>'; }).join('');
    ui.notice.innerHTML = noticeMarkup(state, result.primary);
    ui.primary.innerHTML = primaryMarkup(instance, state, result.primary);
    ui.alternatives.innerHTML = result.alternatives.map(function (item) { return alternativeMarkup(instance, item); }).join('');
    ui.alternativesWrap.hidden = !result.alternatives.length;
    var kahTip = instance.root.querySelector('[data-lmp-v14-kah-tip]');
    if (kahTip) kahTip.hidden = !(state.role === 'teacher' && state.goal === 'teach_assess');
    ui.more.hidden = !result.more.length;
    ui.more.open = false;
    ui.moreLabel.textContent = result.more.length + (result.more.length === 1 ? ' weitere passende Möglichkeit' : ' weitere passende Wege');
    ui.moreList.innerHTML = result.more.map(function (item) { return alternativeMarkup(instance, item); }).join('');
    ui.ai.innerHTML = aiMarkup(instance, state, result.primary);
    ui.liveWrap.hidden = true;
    ui.live.innerHTML = '';
  }

  function resultLead(state, item) {
    var subject = SUBJECT_LABELS[state.subject] || 'dein Thema';
    var timing = state.urgency ? ' und passt zu deinem Zeitrahmen „' + URGENCY_LABELS[state.urgency] + '“' : '';
    if (state.role === 'teacher') {
      return 'Dieser Einstieg passt am besten zu „' + GOAL_LABELS[state.goal] + '“ in ' + subject + timing + '.';
    }
    var who = state.role === 'child' ? 'für dein Kind' : 'für dich';
    return 'Diese Lernhilfe ist ' + who + ' der sinnvollste nächste Schritt für ' + subject + timing + '.';
  }

  function noticeMarkup(state, primary) {
    if (state.topic && !primary.topicMatch) {
      return '<p class="lmp-guided-check-v15__notice">Einstieg für dein Fach. Wähle dort dein Thema und das passende Niveau aus.</p>';
    }
    return '';
  }

  function primaryMarkup(instance, state, item) {
    return '<article class="lmp-guided-check-v14__primary-card">' +
      '<div class="lmp-guided-check-v15__card-head">' + mediaMarkup(item) +
      '<div><span class="lmp-guided-check-v15__eyebrow">Dein erster Schritt · ' + escapeHTML(TYPE_LABELS[item.type] || 'Lernangebot') + '</span>' +
      '<h4>' + escapeHTML(displayTitle(item)) + '</h4><p>' + escapeHTML(item.text) + '</p></div></div>' +
      '<p class="lmp-guided-check-v15__meta">' + escapeHTML(resourceMeta(item)) + '</p>' +
      '<a class="lmp-guided-check-v14__button lmp-guided-check-v14__button--primary lmp-guided-check-v14__button--wide" href="' + escapeAttribute(internalUrl(instance, item.url)) + '" data-lmp-v14-track="primary">' + escapeHTML(actionLabel(item)) + ' →</a>' +
      '<details class="lmp-guided-check-v15__why"><summary>Warum passt das zu mir?</summary><p>' + escapeHTML(matchReason(state, item)) + '</p></details></article>';
  }

  function alternativeMarkup(instance, item) {
    return '<a class="lmp-guided-check-v14__alternative-card" href="' + escapeAttribute(internalUrl(instance, item.url)) + '" data-lmp-v14-track="alternative">' +
      mediaMarkup(item) + '<span class="lmp-guided-check-v15__row-copy"><strong>' + escapeHTML(displayTitle(item)) + '</strong>' +
      '<small>' + escapeHTML(item.text) + '</small><small class="lmp-guided-check-v15__meta">' + escapeHTML(resourceMeta(item)) + '</small></span><b aria-hidden="true">→</b></a>';
  }

  function matchReason(state, item) {
    var reasons = [];
    if (item.topicMatch) reasons.push('Der Inhalt greift dein Thema „' + state.topic + '“ auf.');
    var boosts = HELP_BOOSTS[state.help] || {};
    if (boosts[item.type] >= 40) reasons.push('Das passt zu deinem Formatwunsch „' + HELP_LABELS[state.help] + '“.');
    else reasons.push('Dieses Angebot unterstützt dein Ziel „' + GOAL_LABELS[state.goal] + '“.');
    if (item.gradeLabel) reasons.push('Am Material angegeben: ' + item.gradeLabel + '.');
    else if (item.kind === 'page' || item.kind === 'product') reasons.push('Eine verlässliche Klassenangabe liegt für diesen Treffer nicht vor. Prüfe das Niveau auf der Zielseite.');
    else reasons.push('Die Übersicht enthält Angebote für unterschiedliche Themen oder Stufen. Wähle dort den passenden Inhalt aus.');
    return reasons.join(' ');
  }

  function aiMarkup(instance, state, primary) {
    var title = state.role === 'teacher' ? 'Mit dem KI-UnterrichtsGuide vertiefen' : 'Mit dem KI-LernGuide vertiefen';
    return '<p class="lmp-guided-check-v15__ai">Noch genauer? <a href="' + escapeAttribute(buildAIUrl(instance, state, primary)) + '" data-lmp-v14-track="ai">' + escapeHTML(title) + ' →</a></p>';
  }

  function buildAIUrl(instance, state, primary) {
    var configured = String(instance.root.getAttribute('data-lmp-v14-ai-base') || '').trim();
    var fallback = window.location.origin + window.location.pathname;
    var url;
    try {
      url = new URL(configured || fallback, window.location.origin);
    } catch (error) {
      url = new URL(fallback);
    }

    var topicPart = state.topic ? ' Konkretes Thema/Problem: ' + state.topic + '.' : '';
    var timingPart = state.urgency ? ' Zeitrahmen: ' + URGENCY_LABELS[state.urgency] + '.' : '';
    var prompt;
    if (state.role === 'teacher') {
      prompt = 'Ich bin Lehrkraft und brauche Unterstützung für ' + SUBJECT_LABELS[state.subject] + ' (' + STAGE_LABELS[state.stage] + '). Ziel: ' + GOAL_LABELS[state.goal] + '. Bevorzugte Hilfe: ' + HELP_LABELS[state.help] + '.' + topicPart + timingPart + ' Der Lernhilfe-Check empfiehlt „' + primary.title + '“. Bitte stelle höchstens zwei gezielte Rückfragen und gib mir dann einen konkreten, praxistauglichen nächsten Schritt mit passenden Materialien oder Vergleichen vom Lernmarktplatz. Weise darauf hin, wenn eine schulinterne Datenschutzprüfung nötig ist.';
    } else {
      var person = state.role === 'child' ? 'Ich suche als Elternteil für mein Kind' : 'Ich suche als Schüler:in';
      prompt = person + ' eine Lernhilfe für ' + SUBJECT_LABELS[state.subject] + ' (' + STAGE_LABELS[state.stage] + '). Ziel: ' + GOAL_LABELS[state.goal] + '. Bevorzugte Hilfe: ' + HELP_LABELS[state.help] + '.' + topicPart + timingPart + ' Der Lernhilfe-Check empfiehlt „' + primary.title + '“. Bitte stelle höchstens zwei kurze Rückfragen und gib dann einen verständlichen nächsten Schritt sowie passende Materialien oder Vergleiche vom Lernmarktplatz. Erkläre altersgerecht und erfinde keine Produktangaben.';
    }
    url.searchParams.set('flyweight-chat', prompt);
    return url.toString();
  }

  function updateEmailFields(instance, state) {
    if (!instance.ui.email) return;
    instance.ui.email.hidden = false;
    var safeTag = function (value) { return String(value || '').toLowerCase().replace(/[^a-z0-9_-]+/g, '-').replace(/^-|-$/g, ''); };
    var tags = ['newsletter', 'lernhilfe-check', 'lmp-guided-v14', 'rolle-' + safeTag(state.role), 'fach-' + safeTag(state.subject), 'ziel-' + safeTag(state.goal)];
    instance.ui.hiddenTags.value = tags.join(',');
    instance.ui.hiddenNote.value = 'Lernhilfe-Check V14: ' + [ROLE_LABELS[state.role], SUBJECT_LABELS[state.subject], STAGE_LABELS[state.stage], GOAL_LABELS[state.goal], HELP_LABELS[state.help]].filter(Boolean).join(' | ');
  }

  function enhanceWithLiveSearch(instance, state, originalCandidates, generation) {
    var desiredType = desiredDiscoveryType(state);
    var hasExactType = originalCandidates.some(function (item) { return item.exact && item.type === desiredType; });
    var collectionPromise = desiredType && !hasExactType && SUBJECT_SEARCH_TOKENS[state.subject]
      ? searchCollections(instance, state, desiredType) : Promise.resolve(null);
    var contentPromise = state.topic.length >= 2 ? searchContent(instance, state) : Promise.resolve([]);
    if ((!desiredType || hasExactType || !SUBJECT_SEARCH_TOKENS[state.subject]) && state.topic.length < 2) return;
    instance.ui.lookup.hidden = false;
    Promise.all([collectionPromise, contentPromise]).then(function (values) {
      if (generation !== instance.state.generation) return;
      var direct = values[1] || [];
      var all = direct.concat(values[0] ? [values[0]] : [], originalCandidates).filter(function (item) { return eligible(item, state); });
      var result = selectResult(rankCandidates(dedupeResources(all), state));
      instance.state.currentResult = result;
      renderResult(instance, state, result);
      instance.ui.status.textContent = direct.length ? 'Die Empfehlung wurde mit passenden Inhalten zu deinem Thema ergänzt.' : 'Deine Empfehlung ist fertig. Die Übersichten helfen dir beim weiteren Eingrenzen.';
    }).catch(function () {
      if (generation === instance.state.generation) instance.ui.status.textContent = 'Deine Empfehlung ist fertig. Die aktuellen Direkttreffer konnten nicht geladen werden.';
    }).finally(function () {
      if (generation === instance.state.generation) instance.ui.lookup.hidden = true;
    });
  }

  function desiredDiscoveryType(state) {
    if (TYPE_SEARCH_TERMS[state.help]) return state.help;
    if (state.role === 'teacher' && state.help === 'ready_materials') return 'worksheets';
    if (state.role === 'teacher') return state.goal === 'teach_materials' || state.goal === 'teach_differentiate' ? 'worksheets' : '';
    if (state.goal === 'exam' || state.goal === 'practice' || state.goal === 'free') return 'worksheets';
    if (state.goal === 'understand') return 'posters';
    if (state.goal === 'improve') return 'books';
    return '';
  }

  function searchCollections(instance, state, type) {
    var query = (SUBJECT_LABELS[state.subject] || '') + ' ' + TYPE_SEARCH_TERMS[type];
    return cachedSuggest(instance, 'collection:' + query.toLowerCase(), query, 'collection', 6).then(function (data) {
      var match = getSuggestResults(data, 'collections').find(function (item) { return relevantCollection(item, state.subject, type); });
      if (!match || !canonicalPath(match.url) || !match.title) return null;
      return resource(type, match.title, canonicalPath(match.url), 'Passende Angebote zu deinem Fach entdecken.', { exact: true, live: true, subject: state.subject, image: match.image && (match.image.url || match.image), kind: 'collection' });
    }).catch(function () { return null; });
  }

  function searchProducts(instance, state) {
    var query = [SUBJECT_LABELS[state.subject], state.topic].filter(Boolean).join(' ');
    var cacheKey = 'product:' + query.toLowerCase();
    return cachedSuggest(instance, cacheKey, query, 'product', 5).then(function (data) {
      return getSuggestResults(data, 'products').filter(function (item) {
        return item && item.title && item.url;
      }).slice(0, 3);
    }).catch(function () { return []; });
  }

  function cachedSuggest(instance, key, query, type, limit) {
    if (instance.state.cache.has(key)) return Promise.resolve(instance.state.cache.get(key));
    var base = internalUrl(instance, '/search/suggest.json');
    var url = base + (base.indexOf('?') === -1 ? '?' : '&') + [
      'q=' + encodeURIComponent(query),
      'resources[type]=' + encodeURIComponent(type),
      'resources[limit]=' + encodeURIComponent(String(limit)),
      'resources[options][unavailable_products]=last'
    ].join('&');
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, 2400);
    return window.fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Predictive search unavailable');
      return response.json();
    }).then(function (data) {
      instance.state.cache.set(key, data);
      return data;
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  function getSuggestResults(data, key) {
    if (!data || !data.resources || !data.resources.results) return [];
    return Array.isArray(data.resources.results[key]) ? data.resources.results[key] : [];
  }

  function relevantCollection(item, subject, type) {
    var haystack = normalizeText((item.title || '') + ' ' + (item.url || ''));
    var subjectTokens = SUBJECT_SEARCH_TOKENS[subject] || [];
    var typeTokens = TYPE_SEARCH_TOKENS[type] || [];
    return subjectTokens.some(function (token) { return haystack.indexOf(token) !== -1; }) &&
      typeTokens.some(function (token) { return haystack.indexOf(token) !== -1; });
  }

  function renderLiveProducts(instance, products) {
    if (!products.length) {
      instance.ui.liveWrap.hidden = true;
      instance.ui.live.innerHTML = '';
      return;
    }
    instance.ui.live.innerHTML = products.map(function (product) {
      var meta = product.vendor ? '<small>' + escapeHTML(product.vendor) + '</small>' : '<small>Direkt-Treffer</small>';
      return '<a class="lmp-guided-check-v14__live-card" href="' + escapeAttribute(internalUrl(instance, product.url)) + '" data-lmp-v14-track="live-product"><span>Material</span><strong>' + escapeHTML(product.title) + '</strong>' + meta + '<b aria-hidden="true">→</b></a>';
    }).join('');
    instance.ui.liveWrap.hidden = false;
  }

  function internalUrl(instance, path) {
    if (!path) return '#';
    if (/^(https?:|mailto:|tel:|#)/i.test(path)) return path;
    var rootUrl = String(instance.root.getAttribute('data-lmp-v14-root-url') || '/');
    if (path.indexOf(rootUrl) === 0 && rootUrl !== '/') return path;
    return rootUrl.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
  }

  function track(action, state, selected) {
    var payload = {
      event: 'lmp_guided_check_v14',
      action: action,
      role: state.role,
      subject: state.subject,
      stage: state.stage,
      goal: state.goal,
      help: state.help,
      urgency: state.urgency || 'none',
      topic_entered: Boolean(state.topic),
      recommendation_type: selected ? selected.type : undefined,
      version: VERSION
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      window.dispatchEvent(new CustomEvent('lmp:guided-check', { detail: payload }));
    } catch (error) {
      
    }
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  }

  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[character];
    });
  }

  function escapeAttribute(value) {
    return escapeHTML(value).replace(/`/g, '&#096;');
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function readCatalog(root) {
    try {
      var data = JSON.parse(root.querySelector('[data-lmp-v15-catalog]').textContent);
      return data.filter(function (item) { return item && canonicalPath(item.url); }).map(function (item) {
        var descriptions = {
          explanations: 'Erklärungen, Beispiele und Übungen zu deinem Fach.',
          podcasts: 'Geschichte hören und mit passenden Aufgaben vertiefen.',
          listening: 'Englisch hören und das Hörverstehen trainieren.',
          worksheets: 'Mit Aufgaben prüfen, was schon sitzt.',
          posters: 'Zusammenhänge übersichtlich wiederholen.',
          flashcards: 'Wichtige Begriffe und Regeln gezielt festigen.'
        };
        return resource(item.type, item.title, item.url, descriptions[item.type] || 'Passende Lernangebote entdecken.', {
          exact: true, subject: item.subject, kind: item.kind, free: item.free, image: item.image
        });
      });
    } catch (error) { return []; }
  }

  function eligible(item, state) {
    var goals = state.role === 'teacher' ? TEACHER_GOAL_WEIGHTS[state.goal] : LEARNER_GOAL_WEIGHTS[state.goal];
    var helps = HELP_BOOSTS[state.help] || {};
    if (item.subject && item.subject !== state.subject) return false;
    if (!formatAvailable(item.type, state)) return false;
    if (state.goal === 'free' && !item.free) return false;
    return Boolean((goals && goals[item.type]) || helps[item.type]);
  }

  function formatAvailable(type, state) {
    if (type === 'podcasts' && state.subject !== 'history') return false;
    if (type === 'listening' && state.subject !== 'english') return false;
    if (['explanations', 'podcasts', 'listening'].indexOf(type) !== -1 && ['preschool', 'primary'].indexOf(state.stage) !== -1) return false;
    return true;
  }

  function updateFormatChoices(instance) {
    var form = instance.ui.form;
    var role = form.querySelector('[name="lmp_role"]:checked');
    var teacher = role && role.value === 'teacher';
    var state = { subject: form.elements.lmp_subject.value, stage: form.elements.lmp_stage.value };
    Array.prototype.forEach.call(form.querySelectorAll('[data-lmp-v15-format]'), function (choice) {
      var type = choice.getAttribute('data-lmp-v15-format');
      var available = formatAvailable(type, state) && instance.catalog.some(function (item) { return item.type === type && item.subject === state.subject; });
      choice.hidden = !available;
      var input = choice.querySelector('input');
      var activeRole = input.name === (teacher ? 'lmp_help_teacher' : 'lmp_help_learner');
      input.disabled = !available || !activeRole;
      if (!available && input.checked) {
        input.checked = false;
        form.querySelector('[name="' + input.name + '"][value="auto"]').checked = true;
      }
    });
    var optional = form.querySelector('.lmp-guided-check-v15__optional');
    if (optional && (form.elements.lmp_topic.value || form.elements.lmp_urgency.value)) optional.open = true;
  }

  function canonicalPath(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:pages|products|collections)\//i.test(url.pathname)) return '';
      return url.pathname.replace(/\/$/, '');
    } catch (error) { return ''; }
  }

  function safeImage(value) {
    try {
      var url = new URL(value, window.location.origin);
      if (url.protocol !== 'https:' || (url.hostname !== 'cdn.shopify.com' && url.origin !== window.location.origin)) return '';
      url.searchParams.set('width', '160');
      return url.toString();
    } catch (error) { return ''; }
  }

  function mediaMarkup(item) {
    var source = item.image && safeImage(item.image);
    if (source) return '<img class="lmp-guided-check-v15__thumb" src="' + escapeAttribute(source) + '" width="72" height="72" loading="lazy" alt="">';
    var icons = {
      explanations: '<path d="M3 5h7l2 2 2-2h7v14h-7l-2 2-2-2H3zM12 7v14M6 9h3M6 12h3M15 9h3M15 12h3"/>',
      podcasts: '<path d="M4 14v-3a8 8 0 0 1 16 0v3M4 13H3v7h4v-7H4Zm16 0h1v7h-4v-7h3Z"/>',
      listening: '<path d="M4 14v-3a8 8 0 0 1 16 0v3M4 13H3v7h4v-7H4Zm16 0h1v7h-4v-7h3Z"/>',
      worksheets: '<path d="M5 3h10l4 4v14H5zM15 3v5h4M8 12h8M8 16h6"/>',
      posters: '<path d="M3 4h18v13H3zM12 17v4M8 21h8M7 13l3-4 3 3 3-5"/>',
      flashcards: '<rect x="7" y="6" width="13" height="15" rx="2"/><path d="M4 17H3V3h13M10 11h7M10 15h5"/>',
      books: '<path d="M5 3h14v18H5a3 3 0 0 1 0-6h14M5 3v12M9 7h6M9 10h4"/>'
    };
    return '<span class="lmp-guided-check-v15__thumb lmp-guided-check-v15__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + (icons[item.type] || '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M8 8h8M8 12h5M8 16h8"/>') + '</svg></span>';
  }

  function resourceMeta(item) {
    var parts = [];
    if (item.kind === 'hub') parts.push('Themenübersicht');
    else if (item.kind === 'collection') parts.push('Sammlung');
    else if (item.kind === 'comparison') parts.push('Übersicht / Vergleich');
    else parts.push(TYPE_LABELS[item.type] || 'Material');
    if (item.free) parts.push('kostenlos');
    if (item.gradeLabel) parts.push(item.gradeLabel);
    else parts.push(item.kind === 'page' || item.kind === 'product' ? 'Niveau auf Zielseite prüfen' : 'Thema und Stufe im Angebot wählen');
    return parts.join(' · ');
  }

  function actionLabel(item) {
    if (item.type === 'explanations') return item.kind === 'page' ? 'Erklärung öffnen' : 'Erklärseiten entdecken';
    if (item.type === 'podcasts') return item.kind === 'product' ? 'Podcast & Material öffnen' : 'Geschichtspodcasts entdecken';
    if (item.type === 'listening') return 'Hörverstehen entdecken';
    if (item.type === 'worksheets') return item.kind === 'product' ? 'Arbeitsblatt öffnen' : 'Arbeitsblätter entdecken';
    return 'Passendes Angebot ansehen';
  }

  function topicTokens(topic) {
    var aliases = { bruche: 'bruch', bruchen: 'bruch', bruchrechnung: 'bruch', binomischen: 'binomisch', binomische: 'binomisch', quadratischen: 'quadratisch', quadratische: 'quadratisch' };
    return normalizeText(topic).replace(/(?:klasse|klassenstufe|stufe)\s*\d+(?:\s*[-–]\s*\d+)?/g, '').split(/[^a-z0-9]+/).filter(function (word) {
      return word.length >= 3 && !/^(und|oder|der|die|das|den|dem|des|ein|eine|einen|einem|zum|zur|fur|von|mit|ich|mochte|will|lernen|verstehen|uben|ubungen|aufgaben|thema|hilfe|bitte|klasse|erklarung|erklaren)$/.test(word);
    }).map(function (word) { return aliases[word] || word; });
  }

  function topicFit(text, topic) {
    var tokens = topicTokens(topic);
    if (!tokens.length) return 0;
    var haystack = normalizeText(text).replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
    var hits = tokens.filter(function (token) {
      var normalized = token.replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
      var stem = normalized.length > 5 ? normalized.replace(/(?:en|er|es|e|n)$/, '') : normalized;
      return haystack.indexOf(normalized) !== -1 || (stem.length >= 4 && haystack.indexOf(stem) !== -1);
    }).length;
    var fit = hits / tokens.length;
    return fit >= 0.66 ? fit : 0;
  }

  function cachedRequest(instance, key, path, asText) {
    if (instance.state.cache.has(key)) return Promise.resolve(instance.state.cache.get(key));
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = window.setTimeout(function () { if (controller) controller.abort(); }, 4500);
    var promise = window.fetch(internalUrl(instance, path), { credentials: 'same-origin', signal: controller ? controller.signal : undefined }).then(function (response) {
      if (!response.ok) throw new Error('Content unavailable');
      return asText ? response.text() : response.json();
    }).catch(function (error) {
      instance.state.cache.delete(key);
      throw error;
    }).finally(function () { window.clearTimeout(timeout); });
    instance.state.cache.set(key, promise);
    return promise;
  }

  function loadSubjectPages(instance, state) {
    var hubs = instance.catalog.filter(function (item) { return item.subject === state.subject && item.kind === 'hub'; });
    if (!formatAvailable('explanations', state)) return Promise.resolve([]);
    return Promise.all(hubs.map(function (hub) {
      return cachedRequest(instance, 'hub:' + hub.url, hub.url, true).then(function (html) {
        var document = new DOMParser().parseFromString(html, 'text/html');
        var container = document.querySelector('#bf-topic') || document.querySelector('main');
        if (!container) return [];
        var seen = Object.create(null);
        return Array.prototype.map.call(container.querySelectorAll('a[href]'), function (link) {
          var url = canonicalPath(link.getAttribute('href'));
          if (!url || url.indexOf('/pages/') === -1 || url === hub.url || seen[url]) return null;
          var box = link.closest('article, .gh-card, .mh-row, .mh-card, li');
          var titleElement = box && box.querySelector('h3, h4');
          var title = (titleElement || link).textContent.replace(/\s+/g, ' ').trim();
          if (!title || /^(Erkl[aä]rung|H[oö]rtext|Material|Arbeitsbl[aä]tter|Zum |Mehr |Alle )/i.test(title)) return null;
          seen[url] = true;
          var fit = topicFit(title + ' ' + url, state.topic);
          if (!fit) return null;
          var image = link.querySelector('img') || (box && box.querySelector('img'));
          var listening = /hoer(?:uebung|verstehen)|listening/.test(url);
          return resource(listening ? 'listening' : 'explanations', title.slice(0, 180), url, listening ? 'Hörtext mit Aufgaben zum Verstehen und Üben.' : 'Das Thema mit Erklärungen und Beispielen erarbeiten.', {
            exact: true, subject: state.subject, free: true, live: true, kind: 'page', topicMatch: fit, image: image && image.getAttribute('src')
          });
        }).filter(Boolean);
      }).catch(function () { return []; });
    })).then(function (groups) { return dedupeResources([].concat.apply([], groups)); });
  }

  function gradeMatch(product, stage) {
    var text = normalizeText((product.tags || []).join(' ') + ' ' + product.title);
    var grades = [];
    var range = /(?:klasse[n]?|kl\.?|jahrgangsstufe[n]?)\s*(\d{1,2})\.?\s*(?:bis|[-–/])\s*(\d{1,2})/g;
    var reverseRange = /(\d{1,2})\.?\s*[-–/]\s*(\d{1,2})\.?\s*klasse[n]?/g;
    [range, reverseRange].forEach(function (regex) {
      var match;
      while ((match = regex.exec(text))) {
        for (var grade = Number(match[1]); grade <= Math.min(13, Number(match[2])); grade += 1) grades.push(grade);
      }
    });
    var single = /(?:klasse[n]?|kl\.?|jahrgangsstufe[n]?)\s*(\d{1,2})\b/g;
    var match;
    while ((match = single.exec(text))) grades.push(Number(match[1]));
    var backwards = /(\d{1,2})\.\s*klasse/g;
    while ((match = backwards.exec(text))) grades.push(Number(match[1]));
    if (!grades.length && /oberstufe|abitur/.test(text)) grades = [11, 12, 13];
    if (!grades.length && /grundschule/.test(text)) grades = [1, 2, 3, 4];
    if (!grades.length && /sekundarstufe i\b|sek i\b/.test(text)) grades = [5, 6, 7, 8, 9, 10];
    grades = grades.filter(function (grade, index, all) { return grade >= 1 && grade <= 13 && all.indexOf(grade) === index; }).sort(function (a, b) { return a - b; });
    if (!grades.length) return { fits: true, known: false, label: '' };
    var ranges = { preschool: [0, 0], primary: [1, 4], grade_5_7: [5, 7], grade_8_10: [8, 10], upper: [11, 13], vocational: [14, 14] };
    var wanted = ranges[stage];
    var fits = !wanted || grades.some(function (grade) { return grade >= wanted[0] && grade <= wanted[1]; });
    var continuous = grades.length === grades[grades.length - 1] - grades[0] + 1;
    var label = 'Klasse ' + (grades.length > 1 && continuous ? grades[0] + '–' + grades[grades.length - 1] : grades.join(', '));
    return { fits: fits, known: true, label: label };
  }

  function productResource(product, state) {
    if (!product || !product.title || product.available === false) return null;
    var tags = Array.isArray(product.tags) ? product.tags : [];
    var text = normalizeText(product.title + ' ' + (product.type || '') + ' ' + tags.join(' '));
    var subjectTokens = SUBJECT_SEARCH_TOKENS[state.subject];
    if (subjectTokens && !subjectTokens.some(function (token) { return text.indexOf(token) !== -1; })) return null;
    if (!subjectTokens && state.subject !== 'multiple') return null;
    var kind = '';
    if (/geschichtspodcast|horgeschichte|lernpodcast/.test(text)) kind = 'podcasts';
    else if (/horverstehen|horubung|listening/.test(text) && state.subject === 'english') kind = 'listening';
    else if (/arbeitsblatt|arbeitsblatter/.test(text)) kind = 'worksheets';
    else if (/lernposter|lernplakat/.test(text)) kind = 'posters';
    else if (/lernkarte/.test(text)) kind = 'flashcards';
    else if (/buch|bucher|prufungstrainer/.test(text)) kind = 'books';
    else return null;
    var fit = topicFit(product.title + ' ' + tags.join(' ') + ' ' + product.handle, state.topic);
    var grade = gradeMatch(product, state.stage);
    if (!fit || !grade.fits) return null;
    var url = canonicalPath(product.url || '/products/' + product.handle);
    if (!url) return null;
    var free = typeof product.price_max === 'number' && product.price_max === 0;
    var descriptions = { podcasts: 'Podcast mit begleitendem Lernmaterial.', listening: 'Englisch hören und mit passenden Aufgaben üben.', worksheets: 'Aufgaben zum Thema bearbeiten und Wissen festigen.', posters: 'Das Thema als übersichtliches Lernposter.', flashcards: 'Begriffe und Regeln zum Thema wiederholen.', books: 'Das Thema mit einem passenden Lernbuch vertiefen.' };
    return resource(kind, product.title, url, descriptions[kind], { exact: true, live: true, free: free, subject: state.subject, kind: 'product', topicMatch: fit, stageKnown: grade.known, gradeLabel: grade.label, image: product.featured_image });
  }

  function searchContent(instance, state) {
    var pagesPromise = loadSubjectPages(instance, state);
    var productsPromise = cachedSuggest(instance, 'topic:' + state.topic.toLowerCase(), state.topic, 'product,page', 8).then(function (data) {
      var products = getSuggestResults(data, 'products');
      return Promise.all(products.slice(0, 8).map(function (product) {
        var path = canonicalPath(product.url);
        if (!path || path.indexOf('/products/') === -1) return Promise.resolve(null);
        return cachedRequest(instance, 'product:' + path, path + '.js', false).then(function (full) { return productResource(full, state); }).catch(function () { return null; });
      }));
    }).catch(function () { return []; });
    return Promise.all([pagesPromise, productsPromise]).then(function (groups) {
      return dedupeResources(groups[0].concat(groups[1]).filter(Boolean)).filter(function (item) { return eligible(item, state); });
    });
  }

  function displayTitle(item) {
    if (item.kind !== 'product') return item.title;
    return item.title.replace(/\s+[–—]\s+(?:Geschichtspodcast|kostenlos|Lernposter|Lernplakat|Arbeitsblatt|Physik-Lernkarte).*$/i, '');
  }

  function keepNativeSelects(instance) {
    function restore() {
      Array.prototype.forEach.call(instance.ui.form.querySelectorAll('select'), function (select) {
        if (select.getAttribute('tabindex') === '-1') select.removeAttribute('tabindex');
      });
    }
    restore();
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(restore);
      observer.observe(instance.ui.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['tabindex'] });
      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target.contains(instance.root)) observer.disconnect();
      });
    }
  }

  function initAll(scope) {
    Array.prototype.slice.call((scope || document).querySelectorAll(ROOT_SELECTOR)).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('click', function (event) {
    var target = event.target.closest ? event.target.closest('[data-lmp-v14-track]') : null;
    if (!target) return;
    var root = target.closest(ROOT_SELECTOR);
    var instance = root ? instances.get(root) : null;
    if (!instance) return;
    track(target.getAttribute('data-lmp-v14-track'), getFormState(instance), instance.state.currentResult && instance.state.currentResult.primary);
  });
})();

